import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { Globals } from '../../../../_globals';
import { Router } from '@angular/router';
import { Lightbox } from 'ngx-lightbox';

@Component({
  selector: 'app-product-warehouse-form-dialog',
  templateUrl: './product-warehouse-form.component.html',
})
export class ProductWarehouseFormComponent implements OnInit, OnChanges {
  @Input() toolkitProduct: any;

  constructor(public globals: Globals, public router: Router, public lightbox: Lightbox) {}

  ngOnInit() {
    // console.log('product details', this.product);
  }

  ngOnChanges(changes: any) {
    this.toolkitProduct = changes.toolkitProduct.currentValue;

    // console.log('toolkitProduct details', this.toolkitProduct);
  }

  openImage(url): void {
    // console.log('open image', this.params.data);

    const image = {
      imageData: { url: url },
      imageUrl: url,
      src: url,
      thumb: url,
    };

    this.lightbox.open([image], 0, {
      centerVertically: true,
      disableScrolling: true,
      showImageNumberLabel: true,
    });

    // const image_window = window.open(url);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/products/product-warehouse-form/product-warehouse-form.component.ts